import { AppName } from '@core/app/scripts/services/app-name';

/**
 * Override the {@link coreModule.appName} value.
 */
export const AppNameProvider: { provide: string; useValue: AppName } = {
  provide: 'appName',
  useValue: 'login',
};
